export default __webpack_public_path__ + "static/media/added-5.ed96622b.svg";